function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-ruler_svg__clip0)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.398 15.012a.688.688 0 00-.467 1.155.639.639 0 00.934 0 .688.688 0 00-.467-1.155z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.914 0l-1.032 1.007 2.703 2.728a.344.344 0 010 .516.369.369 0 01-.27.098.344.344 0 01-.246-.098l-2.727-2.703-1.376 1.376 1.769 1.744a.393.393 0 010 .54.344.344 0 01-.246.1.369.369 0 01-.27-.1l-1.77-1.768-1.375 1.376L12.8 7.518a.442.442 0 010 .541.418.418 0 01-.54 0L9.558 5.332 8.182 6.708 9.95 8.477c.14.143.14.372 0 .516a.369.369 0 01-.54 0l-1.745-1.77L6.29 8.6l2.703 2.727a.344.344 0 010 .516.369.369 0 01-.27.098.344.344 0 01-.246-.098L5.749 9.14l-1.376 1.376 1.77 1.745a.393.393 0 010 .54.344.344 0 01-.246.098.368.368 0 01-.27-.098l-1.77-1.769L0 14.914 5.086 20 20 5.086 14.914 0zM5.406 16.683a1.425 1.425 0 11-2.017-2.015 1.425 1.425 0 012.017 2.015z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-ruler_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgIconRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconRuler;